var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9996 7.00115L7.99959 7.00033L7.99926 11.0003L5.99926 11.0002L5.99975 5.00016L17.9998 5.00115L18 2.00115L21.9997 6.00148L17.9993 10.0011L17.9996 7.00115ZM7.99877 17.0003L17.9988 17.0011L17.9991 13.0011L19.9991 13.0013L19.9986 19.0013L7.99861 19.0003L7.99836 22.0003L3.99869 18L7.99902 14.0003L7.99877 17.0003Z",
    fill: "#818AEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat24Px);
export default __webpack_public_path__ + "static/media/repeat_24px.7fda4c68e51e4bc4e9184212c90dffd6.svg";
export { ForwardRef as ReactComponent };